import { Grid } from '@material-ui/core';
import * as React from 'react';

import './index.scss';

interface IProps {
    content: string;
    isLast: boolean;
}

export const Text: React.FC<IProps> = ({
    content,
    isLast = false,
}) => (
    <Grid
        container
        className="text"
    >
        {
            !isLast && <Grid item md={6} />
        }
        <Grid item md={6}>
            <p dangerouslySetInnerHTML={{ __html: content }} />
        </Grid>
    </Grid>
);
